export default {
  dadosSolicitante: state => state.dadosSolicitante
};
